import { render } from "./DraftMail.vue?vue&type=template&id=40396ca4&scoped=true"
import script from "./DraftMail.vue?vue&type=script&lang=js"
export * from "./DraftMail.vue?vue&type=script&lang=js"

import "./DraftMail.vue?vue&type=style&index=0&id=40396ca4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40396ca4"]])

export default __exports__